import { Badge, Stack, Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { Gpu } from '@/types/device'

type GpuListProps = {
  gpus: Gpu[]
  isJetson?: boolean
}

export const GpuList = ({ gpus, isJetson }: GpuListProps) => {
  if (isJetson) {
    return (
      <Badge size="sm" color="gray.6" variant="light">
        <FormattedMessage id="devices.gpu.integrated" />
      </Badge>
    )
  }

  if (gpus.length === 0) {
    return (
      <Text size="xs" c="yellow">
        <FormattedMessage id="devices.gpu.unavailable" />
      </Text>
    )
  }

  return (
    <Stack gap={6}>
      {gpus.map((gpu) => (
        <Text key={gpu.index} size="sm">
          <FormattedMessage
            id={gpu.name ? 'devices.gpu.indexedName' : 'devices.gpu.indexLabel'}
            values={{ index: gpu.index, name: gpu.name }}
          />
        </Text>
      ))}
    </Stack>
  )
}
